import { addDoc, collection, doc, getDocs, updateDoc } from "@firebase/firestore";

// Plain "water" (not "bottled water", "distilled water", etc.) is a pantry
// staple that should not be added to grocery lists.
export const SKIP_GROCERY_ITEMS = new Set(['water']);

function toSingular(w) {
  if (w.length > 4 && w.endsWith('ies')) return `${w.slice(0, -3)}y`;
  if (w.length > 3 && w.endsWith('es')) return w.slice(0, -2);
  if (w.length > 2 && w.endsWith('s')) return w.slice(0, -1);
  return w;
}

// Normalise a grocery title to a singular lowercase key for dedup comparisons.
export function normaliseGroceryTitle(title) {
  return toSingular((title || '').toLowerCase().trim());
}

export default class Grocery {

  static async addGroceryItem(db, userId, newGroceryItem) {
    // Skip plain tap water — it's always available.
    const titleKey = normaliseGroceryTitle(newGroceryItem.groceryFoodTitle);
    if (SKIP_GROCERY_ITEMS.has(titleKey)) return;

    const groceryRef = collection(db, 'users', userId, 'groceries');
    const grocerySnapshot = await getDocs(groceryRef);
    const grocery = [];
    grocerySnapshot.forEach((groceryItem) => {
      grocery.push({ id: groceryItem.id, ...groceryItem.data() });
    });

    // Match on singular form so "tomato" and "tomatoes" merge automatically.
    const existingGrocery = grocery.find((groceryItem) =>
      normaliseGroceryTitle(groceryItem.groceryFoodTitle) === titleKey &&
      groceryItem.groceryUnit === newGroceryItem.groceryUnit &&
      !groceryItem.groceryIsDone);

    if (existingGrocery) {
      const newQuantity = `${parseFloat(existingGrocery.groceryQuantity) + parseFloat(newGroceryItem.groceryQuantity)}`;
      await updateDoc(doc(db, 'users', userId, 'groceries', existingGrocery.id), { groceryQuantity: newQuantity });
    } else {
      // Save with normalised (singular) title so future adds always match.
      await addDoc(groceryRef, { ...newGroceryItem, groceryFoodTitle: titleKey });
    }
  }

  static async updateGroceryItem(db, userId, groceryId, newGroceryItem) {
    const groceryRef = collection(db, 'users', userId, 'groceries', groceryId);
    await updateDoc(groceryRef, newGroceryItem);
  }

}
